// Devmode logic extracted from index.html

function isDevMode() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('dev') === 'true';
}

// Helper function for clamping attribute values
window.clampAttributeValue = (data, values) => {
  const value = values[data.name] || data.defaultValue || 0;
  if (data.minValue !== undefined && value < data.minValue) {
    return data.minValue;
  }
  if (data.maxValue !== undefined && value > data.maxValue) {
    return data.maxValue;
  }
  return value;
};

document.addEventListener('alpine:init', () => {
  Alpine.store('devMode', {
    enabled: isDevMode(),
    forceUpdate() {
      if (window.updateSW) {
        if (confirm("PWA Update erzwingen?\n\nDies wird die Anwendung neu laden.")) {
          window.updateSW(true);
          window.location.reload();
        }
      } else {
        alert('Service Worker ist nicht verfügbar.\n\nVersuchen Sie einen Hard Refresh (Ctrl+Shift+R).');
      }
    }
  });

  Alpine.store('formatComponentAttributes', (component) => {
    if (!component || !component.attributes) return '';
    return Object.entries(component.attributes)
      .map(([key, value]) => {
        const attr = Alpine.store('attributes')[key];
        const title = attr?.title || key;
        const unit = attr?.unit || '';
        const sign = value > 0 ? '+' : '';
        const explanation = component.explanations?.[key] || '';
        const valueText = `${title}: ${sign}${value}${unit}`.replace(/\s/g, '\u00A0');
        return explanation ? `${valueText}\n${explanation}` : valueText;
      })
      .join('\n\n') || 'Keine Attribute';
  });

  Alpine.store('formatAttributeStats', (attributeData) => {
    if (!attributeData) return '';
    
    // Use the same clamping logic as the UI
    const currentValue = window.clampAttributeValue(attributeData, Alpine.store('values'));
    const evaluation = attributeData.evaluate(currentValue);
    
    const lines = [
      `${attributeData.title}: ${currentValue}${attributeData.unit || ''}`,
      `Status: ${evaluation.status}`,
      `Typ: ${attributeData.type || 'default'}`,
    ];
    
    if (attributeData.minValue !== undefined) {
      lines.push(`Min: ${attributeData.minValue}${attributeData.unit || ''}`);
    }
    if (attributeData.maxValue !== undefined) {
      lines.push(`Max: ${attributeData.maxValue}${attributeData.unit || ''}`);
    }
    if (attributeData.defaultValue !== undefined) {
      lines.push(`Standard: ${attributeData.defaultValue}${attributeData.unit || ''}`);
    }
    
    return lines.join('\n');
  });

  Alpine.data('devTooltip', (component) => ({
    init() {
      if (!Alpine.store('devMode').enabled) return;
      this.$nextTick(() => {
        const el = this.$el;
        let showTooltip = false;
        const tooltip = document.createElement('div');

        tooltip.className = 'fixed z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg whitespace-pre-line text-left';
        tooltip.style.minWidth = '400px';
        tooltip.style.maxWidth = '500px';
        tooltip.style.display = 'none';
        tooltip.textContent = Alpine.store('formatComponentAttributes')(component);

        document.body.appendChild(tooltip);
        el.classList.add('group');

        el.addEventListener('mouseenter', () => {
          showTooltip = true;
          tooltip.style.display = 'block';
          tooltip.style.opacity = '0';
          tooltip.style.transform = 'scale(0.95)';

          // Get the bounding rect of the hovered element
          const elRect = el.getBoundingClientRect();

          // Temporarily show tooltip to measure its size
          tooltip.style.left = '0px';
          tooltip.style.top = '0px';
          tooltip.style.visibility = 'hidden';
          tooltip.style.display = 'block';
          const tooltipHeight = tooltip.offsetHeight;
          const tooltipWidth = tooltip.offsetWidth;
          tooltip.style.visibility = 'visible';

          // Default: show below the element
          let top = elRect.bottom + 8;

          // If not enough space below, show above
          if (top + tooltipHeight > window.innerHeight) {
            top = elRect.top - tooltipHeight - 8;
          }
          // Clamp to viewport
          top = Math.max(10, Math.min(top, window.innerHeight - tooltipHeight - 10));

          // Default: to the right of the element
          let left = elRect.right + 8;
          // If not enough space right, show to the left
          if (left + tooltipWidth > window.innerWidth) {
            left = elRect.left - tooltipWidth - 8;
          }
          // Clamp to viewport
          left = Math.max(10, Math.min(left, window.innerWidth - tooltipWidth - 10));

          tooltip.style.left = left + 'px';
          tooltip.style.top = top + 'px';

          requestAnimationFrame(() => {
            tooltip.style.transition = 'opacity 200ms ease-out, transform 200ms ease-out';
            tooltip.style.opacity = '1';
            tooltip.style.transform = 'scale(1)';
          });
        });

        el.addEventListener('mouseleave', () => {
          showTooltip = false;
          tooltip.style.transition = 'opacity 150ms ease-in, transform 150ms ease-in';
          tooltip.style.opacity = '0';
          tooltip.style.transform = 'scale(0.95)';

          setTimeout(() => {
            if (!showTooltip) {
              tooltip.style.display = 'none';
            }
          }, 150);
        });
      });
    }
  }));

  Alpine.data('devAttributeTooltip', (attributeData) => ({
    init() {
      if (!Alpine.store('devMode').enabled) return;
      this.$nextTick(() => {
        const el = this.$el;
        let showTooltip = false;
        const tooltip = document.createElement('div');

        tooltip.className = 'fixed z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg whitespace-pre-line text-left';
        tooltip.style.minWidth = '300px';
        tooltip.style.maxWidth = '400px';
        tooltip.style.display = 'none';
        tooltip.textContent = Alpine.store('formatAttributeStats')(attributeData);

        document.body.appendChild(tooltip);
        el.classList.add('group');

        el.addEventListener('mouseenter', () => {
          showTooltip = true;
          
          // Update tooltip content with current values each time it's shown
          tooltip.textContent = Alpine.store('formatAttributeStats')(attributeData);
          
          tooltip.style.display = 'block';
          tooltip.style.opacity = '0';
          tooltip.style.transform = 'scale(0.95)';

          // Get the bounding rect of the hovered element
          const elRect = el.getBoundingClientRect();

          // Temporarily show tooltip to measure its size
          tooltip.style.left = '0px';
          tooltip.style.top = '0px';
          tooltip.style.visibility = 'hidden';
          tooltip.style.display = 'block';
          const tooltipHeight = tooltip.offsetHeight;
          const tooltipWidth = tooltip.offsetWidth;
          tooltip.style.visibility = 'visible';

          // Default: show below the element
          let top = elRect.bottom + 8;

          // If not enough space below, show above
          if (top + tooltipHeight > window.innerHeight) {
            top = elRect.top - tooltipHeight - 8;
          }
          // Clamp to viewport
          top = Math.max(10, Math.min(top, window.innerHeight - tooltipHeight - 10));

          // Default: to the right of the element
          let left = elRect.right + 8;
          // If not enough space right, show to the left
          if (left + tooltipWidth > window.innerWidth) {
            left = elRect.left - tooltipWidth - 8;
          }
          // Clamp to viewport
          left = Math.max(10, Math.min(left, window.innerWidth - tooltipWidth - 10));

          tooltip.style.left = left + 'px';
          tooltip.style.top = top + 'px';

          requestAnimationFrame(() => {
            tooltip.style.transition = 'opacity 200ms ease-out, transform 200ms ease-out';
            tooltip.style.opacity = '1';
            tooltip.style.transform = 'scale(1)';
          });
        });

        el.addEventListener('mouseleave', () => {
          showTooltip = false;
          tooltip.style.transition = 'opacity 150ms ease-in, transform 150ms ease-in';
          tooltip.style.opacity = '0';
          tooltip.style.transform = 'scale(0.95)';

          setTimeout(() => {
            if (!showTooltip) {
              tooltip.style.display = 'none';
            }
          }, 150);
        });
      });
    }
  }));
});
